import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/shared/services/auth.service';
import { CoachService } from 'src/shared/services/coach.service';
import { FileService } from 'src/shared/services/file.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-coach-detail',
  templateUrl: './coach-detail.component.html',
  styleUrl: './coach-detail.component.scss'
})
export class CoachDetailComponent implements OnInit {

  @ViewChild('editCoach', {static: true}) public editCoach: NgbModalRef;

  userId: number;
  coach: any;
  modalForm: FormGroup;
  displayedColumns: string[] = ['activity', 'coach_fee'];
  disabledAdd = true;
  schoolActivities: any;
  loading = {
    list: false,
    save: false,
    activity: false
  }
  fileChanged = false;
  disabledEditCoach = false;
  province: any;
  countryList = [];
  nationalityList = [];
  nationalityTypeList = ['KTP', 'PASSPORT'];
  genderList = ['female', 'male'];
  maritalStatusList = ['single', 'married', 'divorced', 'widow/er'];
  religionList = [];
  imageSrc: any;
  profileFile: File;

  checkApiRun: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private coachService: CoachService,
    private modalService: NgbModal,
    private fileService: FileService,
    private translate: TranslateService,
    private rpSer: ResponseService,
    public auth: AuthService
  ) {
  }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular', 'coach');
    this.userId = this.route.snapshot.params['id'];
    if (this.userId) {
      this.getCoachDetail();
    }
  }

  getCoachDetail() {
    this.coachService.getCoachDetail(this.userId).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.coach = response.data;
          this.imageSrc = this.coach.coach_photo_url || null;
          this.initModalForm();
        } else {
          this.rpSer.showAddError(response.message ? response.message : 'An unexpected error occurred. Please check your connection and try again.');     
        }
      },
      error: (error: any) => {
        this.rpSer.showAddError();
      }
    });
  }

  onBack() {
    this.router.navigate(['../../'], {relativeTo: this.route});
  }

  readURL(event: any): void {
    this.fileChanged = true;
    if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        this.profileFile = event.target.files[0];

        const reader = new FileReader();
        reader.onload = e => this.imageSrc = reader.result;

        reader.readAsDataURL(file);
    }
  }

  initModalForm() {
    this.modalForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'username': new FormControl(null),
      'email': new FormControl(null),
      'fullname': new FormControl(null),
      'user_id': new FormControl(null),
      'gender': new FormControl(null),
      'date_of_birth': new FormControl(null),
      'place_of_birth': new FormControl(null),
      'religion_id': new FormControl(null),
      'nationality_id': new FormControl(null),
      'nationality_id_type': new FormControl(null),
      'nationality_id_number': new FormControl(null),
      'npwp': new FormControl(null),
      'marital_status': new FormControl(null),
      'phone_number': new FormControl(null),
      'cellular_number': new FormControl(null),
      'alternative_email_address': new FormControl(null),
      'country_id': new FormControl(null),
      'province_id': new FormControl(null),
      'city': new FormControl(null),
      'full_address': new FormControl(null),
      'postal_code': new FormControl(null),
      'coach_fee': new FormControl(null),
      'bank_account': new FormControl(null),
      'account_number': new FormControl(null),
      'account_holder_name': new FormControl(null),
      'bank_office_brand': new FormControl(null),
      'institute_name': new FormControl(null),
      'institute_office_number': new FormControl(null),
      'institute_email_address': new FormControl(null),
      'institute_address': new FormControl(null),
      'coach_photo_pathfile': new FormControl(null),
      'coach_remarks': new FormControl(null)
    });
    // this.patchCoachData();
  }

  onChangeAcademicYearModal(item: any) {
    this.modalForm.controls['academic_year'].markAsTouched();
    this.modalForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.modalForm.controls['school_location_id'].setValue(null);
    this.trackAddCoachChanges();
  }

  onChangeSchoolLevelModal(item: any) {
    this.modalForm.controls['school_location_id'].markAsTouched();
    this.modalForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.modalForm.controls['school_level_id'].markAsTouched();
    this.modalForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);
    this.trackAddCoachChanges();
  }

  onOpenModalEditCoach() {
    this.modalForm.reset();
    this.patchCoachData();
    this.coachService.getReligionList().subscribe({next: (response: any) => { if (response.error === 0) { this.religionList = response.result.data } }});
    this.coachService.getNationalityList().subscribe({next: (response: any) => { if (response.error === 0) { this.nationalityList = response.result.data } }});
    this.coachService.getCountryList().subscribe({next: (response: any) => { if (response.error === 0) { this.countryList = response.result.data } }});
    this.getProvince();
    this.modalService.open(this.editCoach, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg',
    }).result.then((result: any) => {
    }, (reason: any) => {
    });
  }

  patchCoachData() {
    this.modalForm.controls['username'].setValue(this.coach.username);
    this.modalForm.controls['user_id'].setValue(+this.coach.user_id);
    this.modalForm.controls['email'].setValue(this.coach.email);
    this.modalForm.controls['fullname'].setValue(this.coach.fullname);
    this.modalForm.controls['school_location_id'].setValue(+this.coach.school_location_id);
    this.modalForm.controls['school_level_id'].setValue(+this.coach.school_level_id);
    this.modalForm.controls['academic_year'].setValue(this.coach.academic_year);
    this.modalForm.controls['gender'].setValue(this.coach.gender);
    this.coach.date_of_birth = this.coach.date_of_birth ? new Date(this.coach.date_of_birth).toLocaleString('en-US', { timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit' }) : null;
    this.modalForm.controls['date_of_birth'].setValue(
      this.convertToDateInputFormat(this.coach.date_of_birth) ? this.convertToDateInputFormat(this.coach.date_of_birth) : null
    );
    this.modalForm.controls['place_of_birth'].setValue(this.coach.place_of_birth);
    this.modalForm.controls['religion_id'].setValue(this.coach.religion_id ? +this.coach.religion_id : null);
    this.modalForm.controls['nationality_id'].setValue(this.coach.nationality_id ? this.coach.nationality_id : null);
    this.modalForm.controls['nationality_id_type'].setValue(this.coach.nationality_id_type);
    this.modalForm.controls['nationality_id_number'].setValue(this.coach.nationality_id_number);
    this.modalForm.controls['npwp'].setValue(this.coach.npwp);
    this.modalForm.controls['marital_status'].setValue(this.coach.marital_status);
    this.modalForm.controls['phone_number'].setValue(this.coach.phone_number);
    this.modalForm.controls['cellular_number'].setValue(this.coach.cellular_number);
    this.modalForm.controls['alternative_email_address'].setValue(this.coach.alternative_email_address);
    this.modalForm.controls['country_id'].setValue(this.coach.country_id ? +this.coach.country_id : null);
    this.modalForm.controls['province_id'].setValue(this.coach.province_id ? +this.coach.province_id : null);
    this.modalForm.controls['city'].setValue(this.coach.city);
    this.modalForm.controls['full_address'].setValue(this.coach.full_address);
    this.modalForm.controls['postal_code'].setValue(this.coach.postal_code);
    this.modalForm.controls['coach_fee'].setValue(this.coach.coach_fee);
    this.modalForm.controls['bank_account'].setValue(this.coach.bank_account);
    this.modalForm.controls['account_number'].setValue(this.coach.account_number);
    this.modalForm.controls['account_holder_name'].setValue(this.coach.account_holder_name);
    this.modalForm.controls['bank_office_brand'].setValue(this.coach.bank_office_brand);
    this.modalForm.controls['institute_name'].setValue(this.coach.institute_name);
    this.modalForm.controls['institute_office_number'].setValue(this.coach.institute_office_number);
    this.modalForm.controls['institute_email_address'].setValue(this.coach.institute_email_address);
    this.modalForm.controls['institute_address'].setValue(this.coach.institute_address);
    this.modalForm.controls['coach_photo_pathfile'].setValue(this.coach.coach_photo_pathfile);
    this.modalForm.controls['coach_remarks'].setValue(this.coach.coach_remarks);
  }

  trackAddCoachChanges() {
    this.disabledEditCoach = !this.modalForm.controls['school_location_id'].value ||
                            !this.modalForm.controls['school_level_id'].value ||
                            !this.modalForm.controls['username'].value ||
                            !this.modalForm.controls['fullname'].value ||
                            !this.modalForm.controls['email'].value
  }

  getProvince() {
    const country_id = this.modalForm.get('country_id')?.value;
    this.province = [];
    this.coachService.getProvince({
      country_id: country_id || null
    })
    .subscribe((response: any) => {
      if (response['error'] === 0) {
        this.province = response['result']['data'].slice();
      }
    });
  }

  async onEditCoach() {
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    if (this.fileChanged) {
      const profileFile = await this.fileService.uploadFileS3(this.profileFile, 'school_program/coach');
      const fileParams = { name: profileFile.name, path: profileFile.path, url: profileFile.url, size: profileFile.size };
      this.modalForm.controls['coach_photo_pathfile'].setValue(fileParams.path);
      if (fileParams.size > 5000000) {
        Swal.fire({
          title: 'Warning',
          text: 'File exceed maximum limit of 5MB',
          icon: 'warning'
        });
        return;
      };
    }
    this.checkApiRun = this.coachService.editCoach(this.modalForm.value).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.modalService.dismissAll();
          this.rpSer.showEditSuccess('Coach successfully updated');
          this.getCoachDetail();
        } else {
          this.rpSer.showEditFailed(res.message ? res.message : 'An unexpected error occurred. Please check your connection and try again.');
        }
      },
      error: (err: any) => {
        this.rpSer.showEditFailed(err.message ? err.message : 'An unexpected error occurred. Please check your connection and try again.');
      }
    });
  }

  convertToDateInputFormat(dateString: string): string {
    const [month, day, year] = dateString.split('/');
  
    return `${year}-${month}-${day}`;
  }

}
